export const SIDE_MENU_WIDTH = 240;
export const TOOL_BAR_HEIGHT = 70;
